import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './MaterialIcon.less';

export default function MaterialIcon({
  variant = 'rounded',
  icon,
  classOverride,
  className,
  spin,
  spinBack,
  onClick,
}) {
  return (
    <span
      className={classNames(
        `material-symbols-${variant}`,
        styles.materialIcon,
        classOverride,
        className,
        spin === true ? styles.materialIconSpin : '',
        spinBack === true ? styles.materialIconSpinBack : '',
      )}
      onClick={onClick}
    >
      {icon}
    </span>
  );
}

MaterialIcon.propTypes = {
  variant: PropTypes.oneOf(['rounded', 'outlined']),
};
